<template>
    <div>
        <pagamento
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            v-show="mostrarPagamento"
        ></pagamento>
        <router-view></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamento from '@/app/sgtec/componentes/pagamentos/Pagamento'

export default {
    data() {
        return {
            pagamento: {}
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.pagamento = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter o pagamento.',
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.obterPagamento()
            this.$store.dispatch('setRecarregar', true)
        }
    },

    computed: {
        mostrarPagamento() {
            return this.$route.name == 'Sgtec_Financeiro_Pagamentos_Detalhar'
        }
    },

    components: {
        Pagamento
    },

    created() {
        this.obterPagamento()
    }
}
</script>
